import React from 'react';
import { useToggle } from 'usehooks-ts';

import { Downloadble } from '../../downloadable';

export const DownloadableReel: React.FC<{ url: string; fileName: string }> = ({
  url,
  fileName
}) => {
  const [isDownloadReel, toggleIsDownloadReel] = useToggle(false);

  const onClick = async () => {
    toggleIsDownloadReel();
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to fetch video');
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error('Download failed:', err);
    } finally {
      toggleIsDownloadReel();
    }
  };

  return (
    <Downloadble
      text={'Show reel'}
      bgColor={'#FEB333'}
      icon={'cinematic_blur'}
      disabled={isDownloadReel}
      downloadText={isDownloadReel ? 'Downloading' : 'Download'}
      onClick={onClick}
    />
  );
};
